import axios from 'axios';

const url = 'https://junkit.vonigo.com/api/v1/data/'

import store from './../store';

export default class LocationService {

  public getLocationByClient(data: {}): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(`${url}Locations/`, data, {
          headers: {
            "Content-Type": "application/json"
          }
        })
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public addLocation(data: {}): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(`${url}Locations/`, data, {
          headers: {
            "Content-Type": "application/json"
          }
        })
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
}
